module.exports = __webpack_public_path__ + "static/it-started-with-a-problem-statement-bdb3a5f5f961f37e1badf1f232db3823.png";